<template>
  <div>
    <div class="content">
      <div class="left">
        <df-selectDate :date="choseDate"></df-selectDate>

        <div class="ticket_type">
          <div
            v-for="(item, index) in detail.train.tickets"
            :key="index"
            :class="{
              no_ticket: item.seatNumber == 0,
              active_ticket: item.seatType == seatDetail.seatType
            }"
            @click="changeSeatType(item, item.seatNumber)"
          >
            <div v-if="item.seatType == seatDetail.seatType" class="action_sanjiao"></div>
            <div class="price">¥{{ item.price }}</div>
            <div class="price_line"></div>
            <div class="ticket_name">
              <div>{{ item.seatName }}</div>
              <div>{{ changeText(item.seatNumber) }}</div>
            </div>
          </div>
        </div>
        <!-- v-show='seatDetail.seatType' -->
        <div class="passengers_cont">
          <div class="passengers_title">
            <div>乘客信息 {{ passengerLength }}/5</div>
            <div class="add" @click="addUserAction" v-show="!endorse">
              <PlusCircleFilled :style="{ color: '#FD5839' }" />
              添加乘客
            </div>
          </div>
          <div class="passengers_list" :class="{ moreShow: moreShow }" v-show="!endorse">
            <div
              class="passengers_item"
              v-for="(item, index) in userList"
              :key="index"
              :class="{
                passengers_disabel: item.state != 20,
                passengers_active: item.checked
              }"
              @click="selectUser(index, item.state != 20)"
            >
              <div class="action_sanjiao" v-show="item.checked"></div>
              <div class="name">
                <div>{{ item.name }}</div>
                <div class="tips" v-show="item.state != 20">
                  {{ item.stateValue }}
                </div>
                <div class="tips" v-show="item.state == 20">
                  {{ item.passengerTypeValue }}
                </div>
                <div class="line"></div>
                <div class="operation">
                  <div @click.stop="editUser(index)">编辑</div>
                  <div v-if="item.state == 20" @click.stop="deleteUser(index)">
                    删除
                  </div>
                  <div v-else @click.stop="reloadUser" style="color: #fd5739 !important">
                    刷新
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="passengers_more" @click="moreShow = !moreShow" v-show="userList.length > 8 && !endorse">
            {{ moreShow ? "收起" : "更多乘客" }}
          </div>
        </div>

        <div class="confirm_passengers">
          <template v-for="(item, index) in userList" :key="index">
            <a-row class="confirm_list" v-if="item.checked">
              <a-col :span="6" class="passengers_name">
                {{ item.name || item.passengerName }}
              </a-col>
              <a-col :span="4" class="passengers_type">
                {{ item.passengerTypeValue }}
              </a-col>
              <a-col :span="4" class="passengers_type">
                <span v-show="item.passengerType == 2">限高1.5米</span>
              </a-col>
              <a-col :span="5" class="addchildredn">
                <span v-show="item.passengerType == 1 && !endorse" @click="addChildren(index)">
                  <img src="@assets/img/children.png" />
                  <span>添加儿童<span style="color: #b9b9b9; font-size: 12px">(用成人证件)</span></span>
                </span>
              </a-col>
              <a-col :span="5" class="delete_passengers">
                <div @click="selectUser(index, false)" v-show="!endorse">
                  <CloseCircleOutlined />
                </div>
              </a-col>
            </a-row>

            <a-row class="confirm_list" v-for="(data, dataIndex) in item.children" :key="index">
              <a-col :span="6" class="passengers_name">
                {{ data.name || item.passengerName }}
              </a-col>
              <a-col :span="4" class="passengers_type">
                {{ data.passengerTypeValue }}
              </a-col>
              <a-col :span="4" class="passengers_type">
                <span>限高1.5米</span>
              </a-col>
              <a-col :span="5" class="addchildredn"> </a-col>
              <a-col :span="5" class="delete_passengers">
                <div @click="deleteChildren(index)" v-show="!endorse">
                  <CloseCircleOutlined />
                </div>
              </a-col>
            </a-row>
          </template>
        </div>

        <div class="seat_content" v-show="passengerLength && [3, 4, 11].indexOf(seatDetail.seatType) > -1">
          <df-choseSeat
            :seatType="seatDetail"
            :passengersList="userList"
            :ref="toref"
            @changeSeat="changeSeat"
          ></df-choseSeat>
        </div>

        <div class="contact" v-if="passengerLength">
          <div class="contact_title">联系手机号</div>
          <div class="contact_content">
            <span>手机<span class="tips">(+86)</span>:</span>
            <a-input v-model:value="contact" placeholder="用于购买人接收短信" class="input" />
          </div>
        </div>

        <!-- 保险 -->
        <div class="insurance" v-if="passengerLength && insuranceList.length">
          <div class="insurance_title"><img src="@assets/img/baoxian.png" />全方位保护您的旅程安全</div>
          <div
            class="insurance_content"
            v-for="(item, index) in insuranceList"
            :key="index"
            @click="changeInsurance(item)"
          >
            <div class="insurance-top">
              <div>
                <div class="name">{{ item.insuranceName }}</div>
                <div>
                  保额:
                  <span>{{ insuredAmountText(item.insuredAmount) }}</span>
                </div>
              </div>
              <div class="price">
                ¥{{ item.premium }}/人
                <a-checkbox v-model:checked="item.isSelected" :value="item.id"></a-checkbox>
              </div>
            </div>
            <div class="insurance-bottom">
              阅读[
              <span>保险条款</span>
              ] 和 [
              <span>投保须知</span>
              ]
            </div>
          </div>
        </div>

        <a-button type="primary" class="submitBtn" v-if="passengerLength" @click="submitOrder" :loading="sumitLoading">
          确认{{ endorse ? "改签" : "预定" }}
        </a-button>
      </div>
      <div class="right">
        <div class="ticket_detail">
          <div class="top">
            <div>{{ detail.date }} 出发</div>
            <div class="train_no">{{ detail.train.trainNo }}</div>
          </div>
          <div class="time_cont">
            <div class="state">
              <div>{{ detail.train.fromTime }}</div>
              <div style="font-size: 14px">{{ detail.train.fromStation }}</div>
            </div>
            <div class="often">
              <div>
                {{ detail.train.takeTimeFormat }}
                <img src="@assets/img/idcard.png" class="card" />
              </div>
              <div><img src="@assets/img/cardline.png" /></div>
              <div style="color:#3999fb;cursor: pointer;" @click="stopShowAction(detail.train)">
                经停站
              </div>
              <transition name="fade-transform" mode="out-in">
                <div class="box" v-show="stateListShow">
                  <div class="box_title">
                    经停站<CloseCircleOutlined
                      :style="{
                        color: '#6D7278'
                      }"
                      @click="close"
                    />
                  </div>
                  <div class="box-content">
                    <a-row class="row_content row_title">
                      <a-col span="2"></a-col>
                      <a-col span="5">车站名</a-col>
                      <a-col span="6">到达时间</a-col>
                      <a-col span="6">发车时间</a-col>
                      <a-col span="5">停留时间</a-col>
                    </a-row>
                    <div class="row_list_content">
                      <a-skeleton active v-if="!stopStateList.length" />
                      <a-row class="row_content row_list" v-for="(item, index) in stopStateList" :key="index">
                        <a-col span="2">{{ item.serialNumber }}</a-col>
                        <a-col span="5">{{ item.station }}</a-col>
                        <a-col span="6">{{ item.arrivalTime }}</a-col>
                        <a-col span="6">{{ item.departureTime }}</a-col>
                        <a-col span="5">{{ item.stayTimeSpan }}</a-col>
                      </a-row>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="state">
              <div>{{ detail.train.toTime }}</div>
              <div style="font-size: 14px">{{ detail.train.toStation }}</div>
            </div>
          </div>
        </div>

        <div class="price_content" v-if="passengerLength">
          <div class="price_title">票价信息</div>
          <template v-for="(value, key) in passengerTypeObject" :key="key">
            <div class="price_item" v-if="value.cont && key == 'normal'">
              <div>{{ value.name }}</div>
              <div>¥{{ seatDetail.price }}x{{ value.cont }}张</div>
            </div>
            <div class="price_item" v-if="value.cont && key != 'normal'">
              <div>{{ value.name }}</div>
              <div>¥{{ seatDetail.price / 2 }}x{{ value.cont }}张</div>
            </div>
          </template>
          <template v-for="value in insuranceList" :key="value.id">
            <div class="price_item" v-if="value.isSelected === true">
              <div>{{ value.insuranceName }}</div>
              <div>¥{{ value.premium }}x{{ passengerLength }}份</div>
            </div>
          </template>
          <div class="price_totle">
            <div class="dro">订单总额（ 约 ）</div>
            <div class="num">¥{{ showTotlePrice }}</div>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      title="Title"
      v-model:visible="addvisible"
      :footer="null"
      :closable="false"
      :keyboard="false"
      :maskClosable="false"
    >
      <div class="add_content">
        <a-form :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" :ref="torefs">
          <div class="form_title">{{ editid ? "编辑" : "创建" }}乘客</div>
          <a-form-item label="乘客类型：" class="bdbtm1" name="passengerType">
            <a-radio-group
              v-model:value="form.passengerType"
              button-style="solid"
              :disabled="editid != '' && editState == 20"
            >
              <a-radio-button v-for="(item, index) in typeList" :key="index" :value="item.val">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item label="证件类型：" class="bdbtm1 required" name="cardType">
            <a-select
              v-model:value="form.cardType"
              style="width: 320px"
              :placeholder="'请选择证件类型'"
              size="small"
              :disabled="editid != '' && editState == 20"
            >
              <a-select-option v-for="(item, index) in cardType" :key="index" :value="item.val">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="乘客姓名：" class="bdbtm1" name="name">
            <a-input
              v-model:value="form.name"
              placeholder="请填写乘客姓名"
              style="width: 320px"
              :disabled="editid != '' && editState == 20"
            />
          </a-form-item>

          <a-form-item label="乘客性别：" class="bdbtm1" name="sex" v-if="form.cardType && form.cardType != 1">
            <a-radio-group v-model:value="form.sex" button-style="solid">
              <a-radio-button value="M"> 男 </a-radio-button>
              <a-radio-button value="F"> 女 </a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item
            label="乘客生日："
            class="bdbtm1 required"
            name="birthday"
            v-if="form.cardType && form.cardType != 1"
          >
            <a-date-picker
              v-model:value="form.birthday"
              :disabled="editid != '' && editState == 20"
              type="date"
              placeholder="选择生日"
              valueFormat="YYYY-MM-DD"
              :disabled-date="disabledDate"
              style="width: 320px"
            />
          </a-form-item>
          <a-form-item label="证件号码：" class="bdbtm1" name="cardNo">
            <a-input
              v-model:value="form.cardNo"
              placeholder="请填写证件号码"
              style="width: 320px"
              :disabled="editid != '' && editState == 20"
            />
          </a-form-item>
          <a-form-item label="手机号码：" class="bdbtm1" name="mobile">
            <a-input v-model:value="form.mobile" placeholder="请填写手机号码" style="width: 320px" />
          </a-form-item>
          <a-form-item
            label="电子邮箱："
            class="bdbtm1 required"
            name="email"
            v-if="form.cardType && form.cardType != 1"
          >
            <a-input v-model:value="form.email" placeholder="请填写邮箱" style="width: 320px" />
          </a-form-item>

          <a-form-item>
            <a-button type="primary" class="add_submit" @click="submitAddUser" :loading="loading">
              {{ editid ? "编辑" : "添加" }}乘客
            </a-button>
          </a-form-item>
        </a-form>
        <div class="close_add" @click="addvisible = false">
          <CloseCircleOutlined :style="{ fontSize: '20px' }" />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { ref, watch, provide, computed, nextTick } from "vue";
import {
  PlusCircleFilled,
  FormOutlined,
  DeleteOutlined,
  RedoOutlined,
  CloseCircleOutlined
} from "@ant-design/icons-vue";
import { useRoute, useRouter } from "vue-router";
import homeApi from "@axios/home";
import myApi from "@axios/my";
import { message, Modal } from "ant-design-vue";

export default {
  name: "submitOrder",
  components: {
    PlusCircleFilled,
    FormOutlined,
    DeleteOutlined,
    RedoOutlined,
    CloseCircleOutlined
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    let choseDate = ref("");
    let fromStation = ref("");
    let toStation = ref("");
    let trainNo = ref("");
    let inseatType = "";

    let itemref = [];
    const toref = (el) => {
      itemref.push(el);
    };
    let itemrefs = [];
    const torefs = (el) => {
      itemrefs.push(el);
    };

    let detail = ref({
      train: {}
    });

    let seatDetail = ref({});

    choseDate.value = route.query.choseDate;
    fromStation.value = route.query.fromStation;
    toStation.value = route.query.toStation;
    trainNo.value = route.query.trainNo;
    inseatType = route.query.seatType;

    const getDetail = (tag) => {
      let params = {
        date: choseDate.value,
        fromStation: fromStation.value,
        toStation: toStation.value,
        trainNo: trainNo.value
      };
      homeApi.getTrainsDetail(params).then((res) => {
        detail.value = res;

        if (!tag) {
          detail.value.train.tickets.forEach((ele) => {
            if (ele.seatType == inseatType) {
              seatDetail.value = ele;
            }
          });
          nextTick(() => {
            if (itemref[0]) itemref[0].init();
            seatList = [];
          });
        }
      });
    };

    //获取车票详情
    getDetail();

    let userList = ref([]);

    const getUserList = () => {
      myApi.getUserListNopage({}).then((res) => {
        if (endorse.value) {
          return;
        }

        //原有查看是否需要更新状态
        let idarr = userList.value.map((item) => {
          return item.id;
        });
        let newidarr = res.map((item) => {
          return item.id;
        });
        res.forEach((element) => {
          if (idarr.indexOf(element.id) > -1) {
            userList.value[idarr.indexOf(element.id)].state = element.state;
          } else {
            element.checked = false;
            element.children = [];
            userList.value.push(element);
          }
        });

        userList.value.forEach((element, index) => {
          if (newidarr.indexOf(element.id) > -1) {
          } else {
            userList.value.splice(index, 1);
          }
        });
      });
    };

    //获取乘客列表
    getUserList();

    let contact = ref("");
    let moreShow = ref(false);

    const changeDate = (val) => {
      choseDate.value = val;
      seatList = [];
      seatDetail.value = {};

      if (!endorse.value) {
        userList.value.forEach((ele) => {
          ele.checked = false;
          ele.children = [];
        });
      }

      getDetail(true);
    };

    let seatList = [];

    const changeSeat = (list) => {
      seatList = list;
    };

    const changeSeatType = (type, num) => {
      if (num == 0) return;

      if (seatDetail.value.seatType == type.seatType) {
      } else {
        seatDetail.value = type;
        //清空座位选择'
        nextTick(() => {
          if (itemref[0]) itemref[0].init();
          seatList = [];
        });
      }
    };

    const changeText = (num) => {
      if (num >= 21) {
        return "有";
      } else if (num > 0) {
        return num + "张";
      } else {
        return "无票";
      }
    };

    const selectUser = (index, tag) => {
      if (!seatDetail.value.seatType) {
        message.error("请先选择车票～");
        return;
      }
      if (tag) return;
      if (!userList.value[index].checked) {
        if (passengerLength.value == 5) {
          message.error("最多选择5名乘客");
          return;
        } else if (passengerLength.value == seatDetail.value.seatNumber) {
          message.error("只剩余" + seatDetail.value.seatNumber + "张票了奥");
          return;
        }
        userList.value[index].checked = !userList.value[index].checked;
      } else {
        userList.value[index].checked = !userList.value[index].checked;
        userList.value[index].children = [];
      }
      if (itemref[0]) itemref[0].init();
    };

    const addChildren = (index) => {
      if (passengerLength.value == 5) {
        message.error("最多选择5名乘客");
        return;
      } else if (passengerLength.value == seatDetail.value.seatNumber) {
        message.error("只剩余" + seatDetail.value.seatNumber + "张票了奥");
        return;
      }

      userList.value[index].children.push({
        name: userList.value[index].name,
        passengerTypeValue: "儿童"
      });
      if (itemref[0]) itemref[0].init();
    };

    const deleteChildren = (index) => {
      userList.value[index].children.splice(0, 1);
      if (itemref[0]) itemref[0].init();
    };

    let passengerLength = computed(() => {
      let checklength = 0;
      userList.value.forEach((ele) => {
        if (ele.checked) {
          checklength++;
          if (ele.children.length) {
            checklength += ele.children.length;
          }
        }
      });
      return checklength;
    });

    const passengerTypeObject = computed(() => {
      let object = {
        normal: {
          name: "火车票",
          cont: 0
        },
        child: {
          name: "火车票(儿童)",
          cont: 0
        },
        student: {
          name: "火车票(学生)",
          cont: 0
        },
        disability: {
          name: "火车票(残军)",
          cont: 0
        }
      };

      userList.value.forEach((ele) => {
        if (ele.checked) {
          if (ele.passengerType == 1) {
            object.normal.cont++;
          } else if (ele.passengerType == 2) {
            object.child.cont++;
          } else if (ele.passengerType == 3) {
            object.student.cont++;
          } else if (ele.passengerType == 4) {
            object.disability.cont++;
          }
          ele.children.forEach((element) => {
            object.child.cont++;
          });
        }
      });
      return object;
    });

    // 保险
    let insuranceList = ref([]);
    const getInsuranceList = () => {
      homeApi.getInsuranceList().then((res) => {
        // console.log(res)
        // insuranceList.value = [
        //   {
        //     id: 1,
        //     insuranceName: "乘意险",
        //     insuredAmount: 600000,
        //     premium: 10
        //   },
        //   {
        //     id: 2,
        //     insuranceName: "乘意险2222",
        //     insuredAmount: 200000,
        //     premium: 20
        //   }
        // ]
        insuranceList.value = res;
        insuranceList.value.forEach((item) => {
          item.isSelected = false;
          // if (item.insuranceType === '1002') {
          //   item.isSelected = true
          // }
        });
        console.log(insuranceList.value);
      });
    };
    //获取保险
    getInsuranceList();
    const changeInsurance = (item) => {
      // console.log(item)
      item.isSelected = !item.isSelected;
    };

    const showTotlePrice = computed(() => {
      let price = 0;
      let tickerPrice = seatDetail.value.price;
      userList.value.forEach((ele) => {
        if (ele.checked) {
          if (ele.passengerType == 1) {
            price += tickerPrice;
          } else {
            price += tickerPrice / 2;
          }
          ele.children.forEach((element) => {
            price += tickerPrice / 2;
          });
        }
      });
      let insPrice = 0;
      insuranceList.value.forEach((item) => {
        if (item.isSelected) {
          insPrice += parseFloat(item.premium);
        }
      });
      price += insPrice * passengerLength.value;

      return price;
    });

    let addvisible = ref(false);
    let form = ref({
      passengerType: 1,
      cardType: undefined,
      name: "",
      cardNo: "",
      mobile: "",
      sex: "M",
      birthday: undefined
    });

    //添加编辑刷新删除乘客逻辑相关
    const typeList = ref([
      {
        name: "成人",
        val: 1
      },
      {
        name: "儿童",
        val: 2
      },
      {
        name: "学生",
        val: 3
      },
      {
        name: "残军",
        val: 4
      }
    ]);
    const cardType = ref([
      {
        name: "中国居民身份证",
        val: 1
      },
      {
        name: "护照",
        val: 2
      },
      {
        name: "台湾居民来往大陆通行证",
        val: 3
      },
      {
        name: "港澳居民来往内地通行证",
        val: 4
      },
      {
        name: "外国人永久居留身份证",
        val: 5
      },
      {
        name: "港澳台居民居住证",
        val: 6
      }
    ]);

    var checkPhone = async (rule, value) => {
      if (!value) {
        return Promise.reject("手机号不能为空");
      } else {
        const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          Promise.resolve();
        } else {
          return Promise.reject("请输入正确的手机号");
        }
      }
    };

    let checkDistributorId = (rule, value, callback) => {
      if (!value) {
        return Promise.reject("请选择证件类型");
      } else {
        return Promise.resolve();
      }
    };

    let birthday = (rule, value, callback) => {
      if (!value && form.value.cardType != 1) {
        return Promise.reject("请选择生日");
      } else {
        return Promise.resolve();
      }
    };

    let email = (rule, value, callback) => {
      if (!value && form.value.cardType != 1) {
        return Promise.reject("请输入邮箱");
      } else {
        return Promise.resolve();
      }
    };

    let loading = ref(false);
    let editid = ref("");
    const submitAddUser = () => {
      itemrefs[0]
        .validate()
        .then(() => {
          console.log(1);
          //验证规则是否合法
          loading.value = true;
          let params = {
            name: form.value.name,
            passengerType: form.value.passengerType,
            cardNo: form.value.cardNo,
            mobile: form.value.mobile,
            cardType: form.value.cardType,
            sex: form.value.cardType != 1 ? form.value.sex : null,
            birthday: form.value.birthday
          };
          if (editid.value) {
            params.id = editid.value;
            myApi
              .editUser(params)
              .then((res) => {
                loading.value = false;
                addvisible.value = false;
                message.success("修改成功");
                getUserList();
              })
              .catch((err) => {
                loading.value = false;
              });
          } else {
            myApi
              .addUser(params)
              .then((res) => {
                loading.value = false;
                addvisible.value = false;
                message.success("添加成功");
                getUserList();
              })
              .catch((err) => {
                loading.value = false;
              });
          }
        })
        .catch((err) => {
          loading.value = false;
        });
    };

    const reloadUser = () => {
      getUserList();
    };

    let editState = ref(false);

    const editUser = (index) => {
      editid.value = userList.value[index].id;
      editState.value = userList.value[index].state;
      form.value.passengerType = parseInt(userList.value[index].passengerType);
      form.value.cardType = parseInt(userList.value[index].cardType);
      form.value.name = userList.value[index].name;
      form.value.sex = userList.value[index].sex || "M";
      form.value.birthday = userList.value[index].birthday;
      form.value.email = userList.value[index].email;
      if (userList.value[index].cardNoValue) {
        form.value.cardNo = userList.value[index].cardNoValue;
      } else {
        form.value.cardNo = userList.value[index].cardNo;
      }

      form.value.mobile = userList.value[index].mobileValue;

      addvisible.value = true;
    };

    const addUserAction = () => {
      form.value.passengerType = 1;
      form.value.cardType = undefined;
      form.value.sex = "M";
      form.value.birthday = undefined;
      form.value.name = "";
      form.value.cardNo = "";
      form.value.mobile = "";
      form.value.email = "";
      addvisible.value = true;
      editid.value = "";
    };

    const deleteUser = (index) => {
      Modal.confirm({
        content: "请确定删除" + userList.value[index].name + "?",
        onOk() {
          myApi.delUser(userList.value[index].id).then((res) => {
            getUserList();
          });
        },
        cancelText: "取消",
        okText: "确定",
        onCancel() {
          Modal.destroyAll();
        }
      });
    };

    const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
    let sumitLoading = ref(false);
    //提交订单
    const submitOrder = () => {
      // 整理参数
      let params = {
        fromStation: fromStation.value,
        toStation: toStation.value,
        date: choseDate.value,
        trainNo: trainNo.value,
        acceptNoSeat: true,
        buyModel: 0
      };

      if (seatList.length) {
        params.isChooseSeats = true;
        let arr = [];
        seatList.forEach((element, index) => {
          element.forEach((ele) => {
            if (ele.check) {
              arr.push(index + 1 + "" + ele.name);
            }
          });
        });
        params.chooseSeats = arr.join("");
      } else {
        params.isChooseSeats = false;
      }

      if (!contact.value) {
        message.error("请输入联系人");

        return;
      }
      if (!reg.test(contact.value)) {
        message.error("联系人手机号格式不正确");

        return;
      }

      if (!endorse.value) {
        let passengersArr = [];
        userList.value.forEach((element) => {
          if (element.checked) {
            passengersArr.push({
              id: element.id,
              seatType: seatDetail.value.seatType,
              price: seatDetail.value.price,
              children: element.children.length
            });
          }
        });

        params.passengers = passengersArr;
      } else {
        let arrs = [];

        userList.value.forEach((element) => {
          if (element.checked) {
            arrs.push(element.passengerId);
          }
        });

        params.passengerIdList = arrs;
        params.orderCode = endorseJson.orderCode;

        params.seatType = seatDetail.value.seatType;
      }

      params.contact = {
        name: "顾客",
        mobile: contact.value
      };

      //渠道PC
      params.saleChannel = 2;

      // 保险
      var insuranceIds = [];
      insuranceList.value.forEach((item) => {
        if (item.isSelected) {
          insuranceIds.push(item.id);
        }
      });
      params.insuranceIds = insuranceIds;
      // console.log(params);

      sumitLoading.value = true;

      if (!endorse.value) {
        homeApi
          .createOrder(params)
          .then((res) => {
            //成功
            router.push({
              name: "orderDetail",
              query: {
                orderCode: res
              }
            });
          })
          .catch(() => {
            sumitLoading.value = false;
          });
      } else {
        homeApi
          .changeOrder(params)
          .then((res) => {
            router.push({
              name: "endorsed",
              query: {
                orderCode: res.orderCode
              }
            });
          })
          .catch(() => {
            sumitLoading.value = false;
          });
      }

      console.log(params);
    };

    //是否改签？
    let endorse = ref(null);
    let endorseJson;

    if (route.query.endorse) {
      endorse.value = route.query.endorse;
      endorseJson = JSON.parse(localStorage.getItem("endorse"));

      endorseJson.passengersList.forEach((ele) => {
        if (!ele.children) ele.children = [];
        ele.checked = true;
        ele.name = ele.passengerName;
      });

      userList.value = endorseJson.passengersList;

      //添加乘客默认值
    }

    const disabledDate = (current) => {
      return current > moment().add(-1, "d");
    };

    provide("changeDate", changeDate);

    const insuredAmountText = (amount) => {
      if (amount >= 10000) {
        return amount / 10000 + "万";
      } else {
        return amount;
      }
    };

    // 经停
    let stopStateList = ref([]);
    let stateListShow = ref(false);

    const stopShowAction = (item) => {
      stateListShow.value = true;
      // console.log(item);
      let params = {
        trainNo: item.trainNo,
        fromStation: item.fromStation,
        toStation: item.toStation,
        trainDate: choseDate.value
        // trainCode: item.trainLongNo
      };
      homeApi.trainStopStation(params).then((res) => {
        stopStateList.value = res.stations;
      });
    };
    const close = () => {
      stateListShow.value = false;
    };

    return {
      insuredAmountText,
      disabledDate,
      endorse,
      sumitLoading,
      submitOrder,
      deleteUser,
      editState,
      editid,
      addUserAction,
      editUser,
      reloadUser,
      torefs,
      loading,
      submitAddUser,
      cardType,
      typeList,
      showTotlePrice,
      passengerTypeObject,
      changeSeat,
      passengerLength,
      deleteChildren,
      addChildren,
      selectUser,
      userList,
      changeText,
      changeSeatType,
      seatDetail,
      detail,
      form,
      addvisible,
      moreShow,
      contact,
      choseDate,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      toref,
      rules: {
        cardType: [{ validator: checkDistributorId, trigger: "blur" }],
        name: [{ required: true, message: "请输入乘客姓名", trigger: "blur" }],
        birthday: [{ validator: birthday, trigger: "change", type: "object" }],
        cardNo: [{ required: true, message: "请输入证件号码", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        email: [{ validator: email, trigger: "blur", type: "object" }]
      },
      insuranceList,
      changeInsurance,
      stopStateList,
      stopShowAction,
      stateListShow,
      close
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.form_title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  padding-left: 10px;
  padding-bottom: 12px;
  margin-top: 20px;
  border-bottom: 3px solid #cdcccd;
  margin-bottom: 10px;
}
.add_content {
  ::v-deep(.ant-select-selection--single) {
    height: 32px !important;
  }
}

.add_content {
  ::v-deep(.ant-select-selection__rendered) {
    line-height: 32px !important;
  }
}
.close_add {
  position: absolute;
  top: 43px;
  right: 20px;
  cursor: pointer;
}
.bdbtm1 {
  border-bottom: 1px solid #cdcccd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.add_submit {
  width: 144px;
  height: 40px;
  line-height: 40px;
  background: #ffab00;
  border-color: #ffab00;
  border-radius: 5px;
  margin-left: 10px;
  margin-top: 20px;
}
.bdbtm {
  border-bottom: 3px solid #cdcccd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.add_content {
  padding: 20px;
  // background: #F8F8F8;
  border: 0.5px solid #cdcccd;
}
.delete_passengers {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  div {
    cursor: pointer;
  }
}
.addchildredn {
  color: #fd5739;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  cursor: pointer;
  img {
    margin-right: 8px;
  }
}
.confirm_list {
  border-bottom: 1px dashed #bdc0c8;
  padding: 15px 0;
  display: flex;
  align-items: center;
  .passengers_name {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
  }
  .passengers_type {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #6d7278;
  }
}

.moreShow {
  max-height: 500px !important;
}
.passengers_active {
  border-color: #3999fb !important;
}
.passengers_disabel {
  background: #f8f8f8 !important;
  color: #cdcccd !important;
}
.passengers_cont {
  margin-top: 40px;
  position: relative;
  padding-bottom: 40px;
  .passengers_more {
    position: absolute;
    right: 0px;
    color: #6d7278;
    border: 0.5px solid #979797;
    padding: 2px 9px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    cursor: pointer;
    border-radius: 2px;
  }
  .passengers_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    border-bottom: 1px solid #dedfe3;
    padding-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .add {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      border-radius: 2px;
      border: 0.5px solid #cdcccd;
      padding: 4px 7px;
      cursor: pointer;
    }
  }
  .passengers_list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    // max-height: 54px;
    // overflow: hidden;

    .passengers_item {
      margin-right: 7px;
      width: 88px;
      height: 62px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      border-radius: 2px;
      border: 0.5px solid #cdcccd;
      margin-top: 10px;
      cursor: pointer;

      position: relative;
      .action_sanjiao {
        width: 0;
        height: 0;
        border-top: 8px solid transparent !important;
        border-bottom: 8px solid transparent !important;
        border-right: 8px solid transparent !important;
        border-left: 8px solid #3999fb !important;
        position: absolute !important;
        right: -8px !important;
        top: -8px !important;
        transform: rotate(-45deg) !important;
      }

      .operation {
        display: flex;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6d7278;
        justify-content: space-around;

        div {
        }
      }
      .name {
        // line-height: 35px;
        line-height: 17px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 22px;

        div {
          text-align: center;
        }
        .tips {
          font-size: 10px;
          overflow: hidden;
          color: #cdcccd;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 14px;
          margin-bottom: 2px;
        }
        .line {
          height: 0.5px;
          background: #dedfe3;
          width: 74px;
          margin-left: 7px;
        }
      }
    }
  }
}
.input {
  // background: #F8F8F8;
  border: none;
  border-bottom: 1px solid #cdcccd;
  outline: none;
}
.contact {
  margin-top: 20px;
  .contact_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .contact_content {
    margin-top: 13px;
    // background: #F8F8F8;
    border: 0.5px solid #cdcccd;
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    border-bottom: 1px solid #cdcccd;
    .tips {
      font-size: 10px;
    }
    span {
      width: 80px;
    }
  }
}
// 保险
.insurance {
  margin-top: 40px;
  .insurance_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    height: 22px;
    line-height: 22px;
    display: flex;
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    img {
      height: 20px;
      margin-right: 10px;
      vertical-align: sub;
    }
  }
  .insurance_content {
    margin-top: 13px;
    // background: #F8F8F8;
    border: 0.5px solid #cdcccd;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 24px;
    border-bottom: 1px solid #cdcccd;
    border-radius: 2px;
    cursor: pointer;
    .insurance-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #cdcccd;
      font-size: 14px;
      color: #000000;
      font-family: PingFangSC-Light, PingFang SC;
      .name {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #000000;
      }
      span {
        color: #fd5739;
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }
    .insurance-bottom {
      font-family: PingFangSC-Light, PingFang SC;
      span {
        color: #3999fb;
      }
    }
  }
}
.submitBtn {
  background: #ffab00;
  width: 100%;
  border-color: #ffab00;
  height: 68px;
  line-height: 68px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  margin-top: 50px;
  margin-bottom: 30px;
}
.content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
  .left {
    width: 760px;
  }
  .right {
    width: 410px;
  }
}

.ticket_type {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 10px;
  cursor: pointer;
  & > div {
    width: 19%;
    // height:63px;
    margin-right: 18px;
    border-radius: 4px;
    border: 0.5px solid rgba(0, 0, 0, 0.25);
    box-sizing: border-box !important;
    position: relative;
    margin-bottom: 10px;
    .price {
      font-size: 18px;
      text-align: center;
      line-height: 43px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    .price_line {
      margin: 0 5px;
      height: 1px;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.25);
    }
    .ticket_name {
      font-size: 14px;
      padding: 0 10px;
      line-height: 31px;
      display: flex;
      justify-content: space-between;
      font-weight: 300;
      font-family: PingFangSC-Light, PingFang SC;
    }
  }
}
.active_ticket {
  // border: none!important;
  // background: #0D6DBF;
  border-color: #3999fb !important;
  .action_sanjiao {
    width: 0;
    height: 0;
    border-top: 16.5px solid transparent;
    border-bottom: 16.5px solid transparent;
    border-right: 16.5px solid transparent;
    border-left: 16.5px solid #3999fb;
    position: absolute;
    right: -17px;
    top: -17px;
    transform: rotate(-45deg);
  }
}
.no_ticket {
  border: none !important;
  background: #f8f8f8;
  color: rgba(0, 0, 0, 0.25);
}
.ticket_detail {
  background: #fafdff;
  padding: 20px;
  border: 0.5px solid #0d6dbf;
  .top {
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 16px;
    line-height: 20px;
    .train_no {
      color: #fd5839;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
    }
  }
  .time_cont {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .often {
      font-size: 14px;
      text-align: center;
      position: relative;
      .box {
        width: 430px;
        background: #fff;
        border: 0.5px solid #cdcccd;
        padding: 26px 13px;
        position: absolute;
        z-index: 10;
        right: 0;
        top: 70px;
      }
      img {
        width: 95px;
      }

      .card {
        width: 20px;
      }
    }
  }
  .state {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    text-align: center;
  }
}
.price_content {
  padding: 20px;
  background: #f8f8f8;
  border: 0.5px solid #cdcccd;
  border-top: none;
  .price_title {
    font-family: PingFangSC-Medium, PingFang SC;
    font-size: 16px;
    color: #000000;
  }
  .price_item {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
  }
  .price_totle {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 60px;
    font-family: PingFangSC-Medium, PingFang SC;
    .num {
      font-size: 20px;
      color: #ffab00;
      font-family: PingFangSC-Semibold, PingFang SC;
    }
  }
}
// 经停
.box_title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  display: flex;
  justify-content: space-between;
  border-bottom: 3px solid #cdcccd;
  padding-bottom: 6px;
}
.title {
  color: #fff;
  font-size: 20px;
}
.box-content {
  // padding:26px 20px;
  margin-top: 11px;
}
.row_list_content {
  max-height: 400px;
  overflow-y: auto;
}
.row_content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  text-align: center;
}
.row_list {
  margin-bottom: 8px;
}
.row_title {
  margin-bottom: 11px;
}
</style>
